import React, { Component } from 'react';
import { Button, Form, Input, Loader, Segment } from 'semantic-ui-react';
import axios from 'axios';
import { fetchFuelType, fetchManufacturers, fetchStatuses, fetchTypes } from '../Lookups/util';
import { checkOrganizationalUnitsPrivilege, formatListForDropdownOptions } from '../util/util';
import { toast } from 'react-toastify';
import { fetchFaculties } from '../../Lookups/util';

class VehicleForm extends Component {
    constructor(props, context) {
        super(props, context);
        const vehicle = props.vehicle || {};
        this.state = {
            loadingOptions: false,
            saving: false,
            manufacturer: vehicle.manufacturer ? vehicle.manufacturer.id : null,
            type: vehicle.type ? vehicle.type.id : null,
            status: vehicle.status ? vehicle.status.id : null,
            model: vehicle.model || '',
            licencePlate: vehicle.licencePlate || '',
            chassisNumber: vehicle.chassisNumber || '',
            numberOfSeats: vehicle.numberOfSeats || '',
            purchaseYear: vehicle.purchaseYear || '',
            productionYear: vehicle.productionYear || '',
            fuelType: vehicle.fuelType ? vehicle.fuelType.id : null,
            value: vehicle.value || '',
            organizationalUnit: vehicle.organizationalUnit ? vehicle.organizationalUnit.id : null,
        };
        this.fetchLookups = this.fetchLookups.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleLicencePlateChange = this.handleLicencePlateChange.bind(this);
    }

    componentDidMount() {
        this.fetchLookups();
    }

    fetchLookups() {
        this.setState({ loadingOptions: true });
        axios.all([fetchManufacturers(), fetchTypes(), fetchStatuses(), fetchFuelType(), fetchFaculties()])
            .then(axios.spread((manufacturersRes, typesRes, statusesRes, fuelTypesRes, orgUnitsRes) => {
                const manufacturers = formatListForDropdownOptions(manufacturersRes.data);
                const types = formatListForDropdownOptions(typesRes.data);
                const statuses = formatListForDropdownOptions(statusesRes.data);
                const fuelTypes = formatListForDropdownOptions(fuelTypesRes.data);
                const orgUnits = formatListForDropdownOptions(orgUnitsRes.data);

                this.setState({
                    manufacturersOptions: manufacturers,
                    typesOptions: types,
                    statusesOptions: statuses,
                    fuelTypeOptions: fuelTypes,
                    orgUnitOptions: orgUnits,
                    loadingOptions: false,
                });
            }))
            .catch(err => {
                toast('Greška pri dobavljanju podataka.');
                this.setState({
                    loadingOptions: false
                });
            });
    }

    handleLicencePlateChange(event, { value }) {
        this.setState({
            licencePlate: value.toUpperCase()
        });
    }

    handleInputChange(event, {
        name,
        value
    }) {
        this.setState({
            [name]: value !== '' ? value : null,
        });
    }

    sendVehicleRequest() {
        const isEditing = !!this.props.vehicle;
        const {
            manufacturer,
            model,
            type,
            licencePlate,
            chassisNumber,
            numberOfSeats,
            purchaseYear,
            productionYear,
            fuelType,
            status,
            value,
            organizationalUnit,
        } = this.state;

        if (type === null || chassisNumber === '' || licencePlate === '' || chassisNumber === null || licencePlate === null || value !== '' && value <= 0) {
            this.setState({
                typeError: type === null,
                chassisNumberError: chassisNumber === '' || chassisNumber === null,
                licencePlateError: licencePlate === '' || licencePlate === null,
            });

            toast('Nisu sva potrebna polja unešena!');
            return;
        }

        const vehicleRequest = {
            organizationalUnit: organizationalUnit ? { id: organizationalUnit } : null,
            manufacturer: manufacturer ? { id: manufacturer } : null,
            model: model === '' ? null : model,
            type: type ? { id: type } : null,
            licencePlate: licencePlate === '' ? null : licencePlate,
            chassisNumber: chassisNumber === '' ? null : chassisNumber,
            numberOfSeats: numberOfSeats === '' ? null : numberOfSeats,
            productionYear: productionYear === '' ? null : productionYear,
            purchaseYear: purchaseYear === '' ? null : purchaseYear,
            status: status ? { id: status } : null,
            fuelType: fuelType ? { id: fuelType } : null,
            value: value === '' ? null : value,
            id: null,
            optLock: null,
        };

        if (isEditing) {
            vehicleRequest.id = this.props.vehicle.id;
            vehicleRequest.optLock = this.props.vehicle.optLock;
        }

        const apiCall = isEditing
            ? axios.put('/assets/vehicle/', vehicleRequest)
            : axios.post('/assets/vehicle/', vehicleRequest);

        this.setState({ saving: true }, () => {
            apiCall
                .then(res => {
                    this.setState({ saving: false });
                    toast(isEditing ? 'Vozilo je uspješno izmijenjeno.' : 'Vozilo je uspješno dodano.');
                    this.props.onRefreshData();
                    this.props.onCloseForm();
                })
                .catch(err => {
                    this.setState({ saving: false });
                    toast(isEditing ? 'Došlo je do greške prilikom izmjene vozila!' : 'Došlo je do greške prilikom dodavanja vozila!');
                });
        });
    }

    render() {
        const isEditing = !!this.props.vehicle;
        const { saving } = this.state;

        if (this.state.loadingOptions) {
            return <div style={{
                paddingTop: '100px',
                paddingBottom: '100px'
            }}><Loader active inline="centered"/></div>;
        }

        return (
            <div>
                <Segment secondary clearing>
                    <Form noValidate>
                        {checkOrganizationalUnitsPrivilege(this.props.activeRole) &&
                            <Form.Group widths="equal">
                                <Form.Dropdown
                                    clearable
                                    label="Članica"
                                    placeholder="Članica"
                                    value={this.state.organizationalUnit}
                                    onChange={this.handleInputChange}
                                    name="organizationalUnit"
                                    options={this.state.orgUnitOptions}
                                    search
                                    selection
                                    fluid
                                />
                            </Form.Group>
                        }
                        <Form.Group widths="equal">
                            <Form.Dropdown
                                clearable
                                label="Proizvođač"
                                placeholder="Proizvođač"
                                value={this.state.manufacturer}
                                onChange={this.handleInputChange}
                                name="manufacturer"
                                options={this.state.manufacturersOptions}
                                search
                                selection
                                fluid
                            />
                            <Form.Field
                                label="Model"
                                control={Input}
                                name="model"
                                value={this.state.model}
                                onChange={this.handleInputChange}
                                placeholder="Model"
                            />
                            <Form.Dropdown
                                clearable
                                label="Tip"
                                placeholder="Tip"
                                value={this.state.type}
                                onChange={this.handleInputChange}
                                name="type"
                                options={this.state.typesOptions}
                                search
                                fluid
                                selection
                                required
                                error={this.state.typeError}
                            />
                        </Form.Group>

                        <Form.Group widths="equal">
                            <Form.Field
                                type="text"
                                label="Tablice"
                                control={Input}
                                name="licencePlate"
                                value={this.state.licencePlate}
                                onChange={this.handleLicencePlateChange}
                                placeholder="Tablice"
                                required
                                error={this.state.licencePlateError}
                            />
                            <Form.Field
                                type="text"
                                label="Broj šasije"
                                control={Input}
                                name="chassisNumber"
                                value={this.state.chassisNumber}
                                onChange={this.handleInputChange}
                                placeholder="Broj šasije"
                                required
                                error={this.state.chassisNumberError}
                            />
                            <Form.Dropdown
                                clearable
                                label="Tip goriva"
                                placeholder="Tip goriva"
                                value={this.state.fuelType}
                                onChange={this.handleInputChange}
                                name="fuelType"
                                options={this.state.fuelTypeOptions}
                                selection
                                search
                                fluid
                            />
                        </Form.Group>

                        <Form.Group widths="equal">
                            <Form.Field
                                type="number"
                                label="Godina proizvodnje"
                                control={Input}
                                name="productionYear"
                                value={this.state.productionYear}
                                onChange={this.handleInputChange}
                                placeholder="Godina proizvodnje"
                            />
                            <Form.Field
                                type="number"
                                label="Godina nabavke"
                                control={Input}
                                name="purchaseYear"
                                value={this.state.purchaseYear}
                                onChange={this.handleInputChange}
                                placeholder="Godina nabavke"
                            />
                            <Form.Field
                                type="number"
                                label="Broj sjedišta"
                                control={Input}
                                name="numberOfSeats"
                                value={this.state.numberOfSeats}
                                onChange={this.handleInputChange}
                                placeholder="Broj sjedišta"
                            />
                        </Form.Group>

                        <Form.Group widths="equal">
                            <Form.Dropdown
                                clearable
                                label="Status"
                                placeholder="Status"
                                value={this.state.status}
                                onChange={this.handleInputChange}
                                name="status"
                                options={this.state.statusesOptions}
                                selection
                                search
                                fluid
                            />
                            <Form.Field
                                type="number"
                                min={0}
                                step="0.01"
                                label="Vrijednost (BAM)"
                                control={Input}
                                name="value"
                                value={this.state.value}
                                onChange={this.handleInputChange}
                                placeholder="Vrijednost (BAM)"
                            />
                        </Form.Group>
                        <Button
                            floated="right"
                            onClick={this.props.onCloseForm}
                            basic
                            color="blue"
                            disabled={saving}
                        >Odustani
                        </Button>
                        <Button
                            floated="right"
                            color="blue"
                            loading={saving}
                            disabled={saving}
                            onClick={
                                () => {
                                    this.sendVehicleRequest();
                                }
                            }
                        >
                            {isEditing ? 'Izmijeni' : 'Dodaj'}
                        </Button>
                    </Form>
                </Segment>
            </div>
        );
    }
}

export default VehicleForm;



// WEBPACK FOOTER //
// ./src/views/Assets/Vehicles/VehicleForm.js